import React, { useState } from "react";
import AdminLayout from "./AdminLayout";
import { useSettings } from "../context/SettingsContext";

export default function AdminInvoice() {
  const settings = useSettings();
  const [invoiceData, setInvoiceData] = useState({
    invoiceNumber: `INV-${new Date().toISOString().slice(0, 10).replace(/-/g, "")}-${Math.floor(1000 + Math.random() * 9000)}`,
    date: new Date().toISOString().slice(0, 10),
    customerName: "",
    customerWhatsApp: "",
    items: [
      { name: "", brand: "", type: "", qty: 1, price: 0 }
    ],
    notes: "Pembayaran dapat dilakukan melalui transfer ke rekening berikut:",
    bankName: settings.bank_name || "BCA",
    bankAccount: settings.bank_account || "XXXXXXXX",
    bankOwner: settings.site_name || "HandyCraft Bali"
  });

  const subtotal = invoiceData.items.reduce((acc, item) => acc + (item.qty * item.price), 0);

  // Validation logic
  const isFormValid = () => {
    const hasCustomer = invoiceData.customerName.trim().length > 0;
    const hasValidItems = invoiceData.items.length > 0 && invoiceData.items.every(item => 
      item.name.trim().length > 0 && item.price > 0
    );
    return hasCustomer && hasValidItems;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInvoiceData({ ...invoiceData, [name]: value });
  };

  const handleItemChange = (index, e) => {
    const { name, value } = e.target;
    const newItems = [...invoiceData.items];
    newItems[index] = { ...newItems[index], [name]: name === 'qty' || name === 'price' ? parseFloat(value) || 0 : value };
    setInvoiceData({ ...invoiceData, items: newItems });
  };

  const addItem = () => {
    setInvoiceData({
      ...invoiceData,
      items: [...invoiceData.items, { name: "", brand: "", type: "", qty: 1, price: 0 }]
    });
  };

  const removeItem = (index) => {
    const newItems = invoiceData.items.filter((_, i) => i !== index);
    setInvoiceData({ ...invoiceData, items: newItems });
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <AdminLayout>
      <div className="invoice-container">
        <div className="no-print">
          <div className="invoice-header-actions">
            <div>
               <h2 className="section-title">Cetak Invoice</h2>
               <p className="section-subtitle">Buat dokumen penagihan profesional secara instan.</p>
            </div>
            <div className="action-buttons">
               <button 
                onClick={handlePrint} 
                disabled={!isFormValid()}
                className={`btn-action btn-print ${!isFormValid() ? 'disabled' : ''}`}
                title={!isFormValid() ? "Isi Nama Pelanggan, Nama Barang & Harga untuk mencetak" : "Cetak Invoice"}
               >
                 Cetak / Save PDF
               </button>
               <button className="btn-action btn-download">Download PDF</button>
               <button className="btn-action btn-report">Laporan</button>
            </div>
          </div>

          <div className="invoice-main-grid">
            {/* Form Side */}
            <div className="invoice-form-side">
              <div className="invoice-form-card">
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Nomor Invoice</label>
                    <input type="text" name="invoiceNumber" value={invoiceData.invoiceNumber} onChange={handleInputChange} className="form-input" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Tanggal</label>
                    <input type="date" name="date" value={invoiceData.date} onChange={handleInputChange} className="form-input" />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Nama Customer</label>
                    <input type="text" name="customerName" value={invoiceData.customerName} placeholder="Masukkan nama pelanggan" onChange={handleInputChange} className="form-input" style={{ borderColor: !invoiceData.customerName.trim() ? '#ffdada' : 'var(--border)' }} />
                    {!invoiceData.customerName.trim() && <small style={{ color: '#ff6b6b', fontSize: '0.7rem' }}>Wajib diisi</small>}
                  </div>
                  <div className="form-group">
                    <label className="form-label">No. WhatsApp</label>
                    <input type="text" name="customerWhatsApp" value={invoiceData.customerWhatsApp} placeholder="Contoh: 0812..." onChange={handleInputChange} className="form-input" />
                  </div>
                </div>

                <div className="items-section">
                  <div className="items-header">
                    <h4 className="sub-title">Barang / Jasa</h4>
                    <button onClick={addItem} className="btn-add-item">+ Tambah Baris</button>
                  </div>
                  {invoiceData.items.map((item, index) => (
                    <div key={index} className="item-row-card">
                       <div className="item-inputs-grid">
                          <div className="form-group span-full">
                            <label className="field-hint">Nama Produk / Jasa</label>
                            <input type="text" name="name" placeholder="Contoh: Tas Anyaman rotan..." value={item.name} onChange={(e) => handleItemChange(index, e)} className="form-input" style={{ borderColor: !item.name.trim() ? '#ffdada' : 'var(--border)' }} />
                          </div>
                          <div className="form-group">
                            <label className="field-hint">Merk</label>
                            <input type="text" name="brand" placeholder="Merk" value={item.brand} onChange={(e) => handleItemChange(index, e)} className="form-input" />
                          </div>
                          <div className="form-group">
                            <label className="field-hint">Type</label>
                            <input type="text" name="type" placeholder="Type" value={item.type} onChange={(e) => handleItemChange(index, e)} className="form-input" />
                          </div>
                          <div className="form-group">
                            <label className="field-hint">Qty</label>
                            <input type="number" name="qty" value={item.qty} onChange={(e) => handleItemChange(index, e)} className="form-input" />
                          </div>
                          <div className="form-group">
                            <label className="field-hint">Harga</label>
                            <input type="number" name="price" value={item.price} onChange={(e) => handleItemChange(index, e)} className="form-input" style={{ borderColor: item.price <= 0 ? '#ffdada' : 'var(--border)' }} />
                          </div>
                          <div className="form-group btn-remove-wrapper">
                            {invoiceData.items.length > 1 && (
                              <button onClick={() => removeItem(index)} className="btn-remove-item">Hapus</button>
                            )}
                          </div>
                       </div>
                    </div>
                  ))}
                  {!isFormValid() && (
                    <div style={{ padding: '10px', background: '#fff5f5', borderRadius: '10px', color: '#c53030', fontSize: '0.8rem', marginTop: '10px', border: '1px solid #fed7d7' }}>
                      ⚠️ Pastikan <b>Nama Pelanggan</b>, <b>Nama Barang</b>, dan <b>Harga</b> sudah terisi untuk mengaktifkan tombol Cetak.
                    </div>
                  )}
                </div>

                <div className="form-group">
                    <label className="form-label">Catatan Rekening & Pembayaran</label>
                    <textarea name="notes" rows="3" value={invoiceData.notes} onChange={handleInputChange} className="form-input" />
                </div>

                <div className="total-summary-card">
                   <span className="total-label">Subtotal</span>
                   <span className="total-value">Rp {subtotal.toLocaleString()}</span>
                </div>
              </div>
            </div>

            {/* Realtime Preview Side */}
            <div className="invoice-preview-side">
               <div className="preview-sticky">
                <div id="printable-invoice" className="invoice-paper">
                  <InvoiceHTML data={invoiceData} subtotal={subtotal} />
                </div>
               </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .invoice-container {
          max-width: 1300px;
          margin: 0 auto;
        }
        
        .invoice-header-actions {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 30px;
          flex-wrap: wrap;
          gap: 20px;
        }

        .section-subtitle {
          color: #666;
          margin-top: 5px;
        }

        .action-buttons {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }

        .btn-action {
          padding: 12px 24px;
          border-radius: 12px;
          font-weight: 700;
          border: none;
          cursor: pointer;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        }

        .btn-print { background: #FF9A9E; color: white; }
        .btn-print:not(.disabled):hover { background: #f87171; transform: translateY(-2px); box-shadow: 0 8px 20px rgba(255, 154, 158, 0.4); }
        
        .btn-print.disabled {
          background: #e2e8f0;
          color: #94a3b8;
          cursor: not-allowed;
          box-shadow: none;
        }

        .btn-download { background: #8FD3F4; color: white; }
        .btn-report { background: white; border: 1px solid var(--border); color: var(--text); }

        .invoice-main-grid {
          display: grid;
          grid-template-columns: 420px 1fr;
          gap: 40px;
          align-items: start;
        }

        @media (max-width: 1100px) {
          .invoice-main-grid { grid-template-columns: 1fr; }
          .invoice-preview-side { order: -1; }
        }

        @media (max-width: 576px) {
          .form-row { grid-template-columns: 1fr; }
          .item-inputs-grid { grid-template-columns: 1fr; }
          .action-buttons { flex-direction: column; width: 100%; }
          .action-buttons button { width: 100%; }
          .invoice-form-card { padding: 20px; }
          .invoice-header-actions { flex-direction: column; }
          .invoice-header-actions > div:first-child { margin-bottom: 15px; }
          .invoice-preview-side { display: none; }
        }

        @media (min-width: 577px) and (max-width: 1100px) {
          .invoice-paper {
            overflow-x: auto;
          }
        }

        .invoice-form-card {
          background: white;
          padding: 30px;
          border-radius: 24px;
          border: 1px solid var(--border);
          box-shadow: var(--shadow);
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
          margin-bottom: 20px;
        }

        .sub-title {
          margin: 0;
          color: var(--secondary);
          font-family: 'Playfair Display', serif;
          font-size: 1.2rem;
        }

        .items-header { 
          display: flex; 
          justify-content: space-between; 
          align-items: center; 
          margin-bottom: 20px; 
          border-bottom: 2px solid #f8fafd;
          padding-bottom: 12px;
        }
        
        .btn-add-item { color: var(--primary); font-weight: 800; cursor: pointer; background: #fffcf0; border: 1px dashed var(--primary); padding: 5px 15px; border-radius: 8px; font-size: 0.8rem; }
        .btn-add-item:hover { background: var(--primary); color: white; }

        .item-row-card {
          background: #fdfaf5;
          padding: 20px;
          border-radius: 18px;
          margin-bottom: 15px;
          border: 1px solid #f1e9d8;
        }

        .item-inputs-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }

        .span-full { grid-column: 1 / -1; }

        .field-hint { font-size: 0.7rem; color: #a0aec0; font-weight: 600; text-transform: uppercase; margin-bottom: 4px; display: block; }
        
        .btn-remove-wrapper { 
          display: flex; 
          align-items: flex-end; 
          justify-content: flex-end;
          grid-column: 1 / -1;
        }
        
        .btn-remove-item { color: #ff5252; font-weight: 600; font-size: 0.8rem; border: none; background: none; cursor: pointer; padding: 5px; }

        .total-summary-card {
          border-top: 2px solid #f8fafd;
          padding-top: 25px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 30px;
        }

        .total-label { font-size: 1.1rem; font-weight: 600; color: var(--text-light); }
        .total-value { font-size: 1.6rem; font-weight: 800; color: var(--secondary); }

        .invoice-preview-side {
          width: 100%;
        }

        .preview-sticky {
          position: sticky;
          top: 30px;
        }

        .invoice-paper {
          background: white;
          border-radius: 4px;
          box-shadow: 0 10px 40px rgba(0,0,0,0.1);
          border: 1px solid #e2e8f0;
          width: 100%;
          min-width: 0;
          overflow-x: auto;
        }

        @media print {
          body * { visibility: hidden !important; }
          #printable-invoice, #printable-invoice * { visibility: visible !important; }
          #printable-invoice { 
            position: fixed !important; 
            left: 0 !important; 
            top: 0 !important; 
            width: 100% !important; 
            box-shadow: none !important; 
            border: none !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          .admin-sidebar, .admin-header, .no-print, .FloatingActions { display: none !important; }
        }
      `}</style>
    </AdminLayout>
  );
}

function InvoiceHTML({ data, subtotal }) {
  return (
    <div style={{ padding: '60px', color: '#1a202c', background: 'white', minHeight: '1120px', width: '100%', minWidth: '0', fontFamily: "'Outfit', sans-serif" }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '60px' }}>
        <div>
          <h1 style={{ fontSize: '3rem', margin: '0 0 5px', color: 'var(--secondary)', fontFamily: "'Playfair Display', serif", fontWeight: 700 }}>{data.bankOwner}</h1>
          <p style={{ color: '#718096', fontSize: '1rem', letterSpacing: '2px', fontWeight: 500 }}>CURATED BALINESE HANDICRAFTS</p>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ color: '#3182ce', fontWeight: '800', fontSize: '1rem', textTransform: 'uppercase', letterSpacing: '4px', marginBottom: '5px' }}>INVOICE</div>
          <div style={{ fontSize: '1.6rem', fontWeight: '800', color: '#1a202c' }}>{data.invoiceNumber}</div>
          <div style={{ marginTop: '20px' }}>
            <div style={{ color: '#718096', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 600 }}>Tanggal Terbit</div>
            <div style={{ fontWeight: '700', fontSize: '1.2rem' }}>{data.date}</div>
          </div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', marginBottom: '60px' }}>
        <div style={{ background: '#f7fafc', padding: '35px', borderRadius: '24px', border: '1px solid #edf2f7' }}>
           <h4 style={{ margin: '0 0 15px', color: '#3182ce', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1.5px', fontWeight: 700 }}>Ditagihkan Kepada</h4>
           <div style={{ fontWeight: '800', fontSize: '1.4rem', marginBottom: '8px', color: '#2d3748' }}>{data.customerName || "-"}</div>
           <div style={{ color: '#4a5568', fontSize: '1.1rem' }}>{data.customerWhatsApp || "—"}</div>
        </div>
        <div style={{ background: '#f7fafc', padding: '35px', borderRadius: '24px', border: '1px solid #edf2f7' }}>
           <h4 style={{ margin: '0 0 15px', color: '#3182ce', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1.5px', fontWeight: 700 }}>Informasi Pembayaran</h4>
           <div style={{ fontWeight: '800', fontSize: '1.4rem', color: 'var(--secondary)', marginBottom: '8px' }}>{data.bankOwner}</div>
           <div style={{ borderTop: '2px dashed #e2e8f0', paddingTop: '15px', marginTop: '10px' }}>
             <div style={{ fontSize: '1rem', marginBottom: '5px' }}><b>Bank</b> : {data.bankName}</div>
             <div style={{ fontSize: '1rem', marginBottom: '5px' }}><b>No. Rek</b> : {data.bankAccount}</div>
             <div style={{ fontSize: '1rem' }}><b>A/n</b> : {data.bankOwner}</div>
           </div>
        </div>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '40px' }}>
        <thead>
          <tr style={{ borderBottom: '3px solid #1a202c', color: '#718096' }}>
            <th style={{ textAlign: 'left', padding: '20px', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Deskripsi Barang</th>
            <th style={{ textAlign: 'left', padding: '20px', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Varian</th>
            <th style={{ textAlign: 'center', padding: '20px', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Qty</th>
            <th style={{ textAlign: 'right', padding: '20px', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Harga Satuan</th>
            <th style={{ textAlign: 'right', padding: '20px', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Total</th>
          </tr>
        </thead>
        <tbody>
          {data.items.length > 0 && data.items[0].name ? data.items.map((item, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #e2e8f0' }}>
              <td style={{ padding: '25px 20px' }}>
                <div style={{ fontWeight: '800', fontSize: '1.2rem', color: '#2d3748' }}>{item.name}</div>
                <div style={{ fontSize: '0.9rem', color: '#718096', marginTop: '4px' }}>Merk: {item.brand || "Handmade"}</div>
              </td>
              <td style={{ padding: '25px 20px', color: '#4a5568' }}>{item.type || "Default"}</td>
              <td style={{ padding: '25px 20px', textAlign: 'center', fontWeight: 'bold' }}>{item.qty}</td>
              <td style={{ padding: '25px 20px', textAlign: 'right' }}>Rp {item.price.toLocaleString()}</td>
              <td style={{ padding: '25px 20px', textAlign: 'right', fontWeight: '800', fontSize: '1.1rem', color: 'var(--secondary)' }}>Rp {(item.qty * item.price).toLocaleString()}</td>
            </tr>
          )) : (
            <tr><td colSpan="5" style={{ padding: '80px', textAlign: 'center', color: '#cbd5e0', fontStyle: 'italic', fontSize: '1.2rem' }}>Daftar barang masih kosong...</td></tr>
          )}
        </tbody>
      </table>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '80px' }}>
         <div style={{ width: '400px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '15px 20px' }}>
              <span style={{ color: '#718096', fontWeight: 600 }}>SUBTOTAL</span>
              <span style={{ fontWeight: '700' }}>Rp {subtotal.toLocaleString()}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '25px 20px', background: 'var(--secondary)', color: 'white', borderRadius: '16px', marginTop: '10px', boxShadow: '0 10px 25px rgba(139, 69, 19, 0.2)' }}>
              <span style={{ fontWeight: '700', fontSize: '1.4rem', letterSpacing: '1px' }}>TOTAL TAGIHAN</span>
              <span style={{ fontWeight: '800', fontSize: '1.8rem' }}>Rp {subtotal.toLocaleString()}</span>
            </div>
         </div>
      </div>

      <div style={{ background: '#fffaf0', padding: '40px', borderRadius: '30px', border: '2px solid #feebc8' }}>
         <h4 style={{ margin: '0 0 20px', fontSize: '1.1rem', color: '#dd6b20', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px' }}>📜 Syarat & Ketentuan</h4>
         <p style={{ fontSize: '1rem', color: '#4a5568', lineHeight: '1.8', whiteSpace: 'pre-wrap' }}>
            {data.notes}
            {"\n\n"}
            Harap lakukan konfirmasi pembayaran melalui WhatsApp Admin dengan melampirkan bukti transfer dan Nomor Invoice <b>{data.invoiceNumber}</b>.
            {"\n\n"}
            <span style={{ color: '#c05621', fontWeight: '700' }}>Terima kasih atas kunjungan dan kepercayaan Anda pada produk lokal Bali kami.</span>
         </p>
      </div>

      <div style={{ marginTop: '80px', textAlign: 'center', color: '#a0aec0', fontSize: '0.9rem', borderTop: '2px solid #f7fafc', paddingTop: '40px' }}>
         Invoice ini adalah bukti tagihan resmi dari <b>{data.bankOwner}</b>. <br/>
         www.handycraftbali.co.id
      </div>
    </div>
  );
}
